import React,{Component} from 'react';
import "./index.less";
import {NavBar,Toast,ListView,Icon,Picker} from "antd-mobile";
import {connect} from "react-redux";
import {selectBill} from "../../../../service/waterBillService";
let pageIndex = 1;
let pageSize = 10;
const dataError = require('../../../../common/image/wrongData.png');
const noOrder = require('../../../../common/image/noOrder.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class DealList extends Component{
    constructor(props) {
        super(props);
        console.log(props)
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            preparationData:[
                {value:'全部',label:'全部'},
                {value:'收入',label:'收入'},
                {value:'支出',label:'支出'},
            ],
            dataSource,
            showModal:false,
            preparation:'全部',
            isLoading: true,
            notDataLoading:0,
            listData:[],
        }
    };
    componentDidMount() {
        if(this.props.history.location.state.startDate && this.props.history.location.state.userType && this.props.history.location.state.endDate){
            pageIndex = 1;
            let params={
                token: this.props.userInfo.token,
                data:{
                    "billQuantum":this.props.history.location.state.propDate.replace(/[\u4E00-\u9FA5]/g,''),
                    "businessType":this.props.history.location.state.userType,
                    "startDate":this.props.history.location.state.startDate,
                    "endDate":this.props.history.location.state.endDate,
                    "pageSize":pageSize,
                    "pageNum":1,
                    "billType":this.state.preparation ==='全部'? '':(this.state.preparation=== '收入' ? 0 : 1),
                }
            };
            console.log(params)
           this._getOrderList(params);
        }else{
            Toast.info('暂无交易记录');
            this.setState({
                notDataLoading:1,
                isLoading:false
            })
        }
       
    }
    _getOrderList(params){
        selectBill(params).then((res) => {
            console.log(res)
                if(res.data.code == "0000"){
                    if (res.data.data.list.length > 0) {
                        this._setDataSource(res.data.data);
                        this.setState({notDataLoading:0});
                        // this.setState({data:res.data.data.list})
                    }else{
                        this.setState({isLoading: false,notDataLoading:1});
                    }
                }else {
                    this.setState({notDataLoading:2,isLoading: false});
                    Toast.info(res.data.msg,3)
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
     //数据拼接
     _setDataSource(data) {
        const allData = [...this.state.listData, ...data.list];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            listData: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                token: this.props.userInfo.token,
                data:{
                    "billQuantum":this.props.history.location.state.propDate.replace(/[\u4E00-\u9FA5]/g,''),
                    "businessType":this.props.history.location.state.userType,
                    "startDate":this.props.history.location.state.startDate,
                    "endDate":this.props.history.location.state.endDate,
                    "pageSize": pageSize,
                    "pageNum": ++pageIndex, 
                    "billType":this.state.preparation ==='全部'? '':(this.state.preparation=== '收入' ? 0 : 1),
                    
                },
            };
            this._getOrderList(params);
        }
    };
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noData">
                        <img src={noOrder} />
                        <p>暂无交易记录</p>
                    </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
  
    showModal = (v) =>{
        this.setState({
            showModal:false,
            preparation:v.join(),
            listData:[],
            isLoading:true,
        })
        let top = document.getElementsByClassName("am-list-view-scrollview")
        if( top[0]){
            top[0].scrollTop = 0;
        }
        let params={
            token: this.props.userInfo.token,
            data:{
                "billQuantum":this.props.history.location.state.propDate.replace(/[\u4E00-\u9FA5]/g,''),
                "businessType":this.props.history.location.state.userType,
                "startDate":this.props.history.location.state.startDate,
                "endDate":this.props.history.location.state.endDate,
                "pageSize":pageSize,
                "pageNum":1,
                "billType":v.join() ==='全部'? '' :(v.join() === '收入' ? 0 : 1),
            }
        };
        this._getOrderList(params);
    }
    icon  =(v) => {
        if(v === 1 || v === 5 || v === 6 || v===7){
            return 'icon iconfont iconxiadantubiao'
        }
        if(v === 2 || v === 3 || v === 4){
            return 'icon iconfont iconfenliuyewu'
        }
        if(v === 10){
            return 'icon iconfont icondaihuo'
        }
    }
    type =(v) => {
        if(v === 1){
            return '主线司机订单完成'
        }
        if(v === 2){
            return '关闭待组合订单'
        }
        if(v === 3){
            return '分流报单'
        }
        if(v === 4){
            return '分流司机完成分流订单'
        }
        if(v === 5){
            return '专车预约司机完成订单'
        }
        if(v === 6){
            return '城内订单乘客完成支付生成城内司机流水'
        }
        if(v === 7){
            return '接驳订单完成支付生成流水'
        }
        if(v === 10){
            return '带货订单'
        }
    }
    render(){
        const _renderRow = (res, index, rowID) => (
            <div className="listContent" key={rowID} onClick={() => this.props.history.push('/DealDetail',{id:res.id})}>
                <div><i className={this.icon(res.source)}/></div>
                <div className="span"><span>{res.createTime}</span><div className="type">{this.type(res.notes)}</div></div>
                <div className="money">{res.amount}</div>
            </div>
        )
        return(
            <div className="DealList">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >交易明细列表</NavBar>
                <div className="header"><span>筛选类型:</span><div onClick={()=>this.setState({showModal:true})}>{this.state.preparation} <i className="icon iconfont iconzhandianxialaxuanze"/></div></div>
                <Picker
                    cols={1}
                   extra={'选择司机'}
                   visible={this.state.showModal}
                   data={this.state.preparationData}
                   onDismiss={()=>this.setState({showModal:false})}
                   onOk={(v) =>this.showModal(v)}
               ></Picker>
                <div className="content">
                    {this.notData()}
                    {
                        this.state.notDataLoading == 0  ?
                            <ListView
                                ref={el => this.lv = el}
                                dataSource={this.state.dataSource}
                                renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                                renderRow={_renderRow}
                                style={{
                                    height: '100%',
                                    overflow:'auto'
                                }}
                                onEndReached={this._onEndReached.bind(this)}
                                scrollRenderAheadDistance={300}
                                onEndReachedThreshold={30}
                            />: null
                    }        
                           
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/Index/DealList/index.js